import {apiWithToken} from '../../../systems/api';
import {API_URL} from '../../../systems/globalContant';

export default {
    generateToken: () => apiWithToken.post(API_URL.DEFAULT + `/auth/token`, {}, {loading: false}),
}
